"use client"

import { useCallback } from "react"
import { usePostHog } from "posthog-js/react"
import { showNotification } from "@/lib/notifications"
import { resetAuthenticatedPostHogIdentity } from "@/lib/posthog/identity"

export function useLogout() {
  const posthog = usePostHog()

  const performLogout = useCallback(async () => {
    try {
      try {
        resetAuthenticatedPostHogIdentity({
          client: posthog,
          storage: window.localStorage,
        })
      } catch {
        // Analytics cleanup must never block account logout.
      }
      window.location.replace("/api/auth/logout")
    } catch (err) {
      showNotification({
        type: "error",
        title: "Error while logging out",
        message: (err as any)?.message ?? "Try again in a few seconds or reach your administrator for help.",
      })
    }
  }, [posthog])

  return { performLogout }
}
